/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_Invalid_DeadlineInputs */

const en_task_settings_invalid_deadline = /** @type {(inputs: Task_Settings_Invalid_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a nonnegative whole number.`)
};

const pt_br2_task_settings_invalid_deadline = /** @type {(inputs: Task_Settings_Invalid_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um número inteiro maior ou igual a zero.`)
};

/**
* | output |
* | --- |
* | "Enter a nonnegative whole number." |
*
* @param {Task_Settings_Invalid_DeadlineInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_invalid_deadline = /** @type {((inputs?: Task_Settings_Invalid_DeadlineInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Invalid_DeadlineInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_invalid_deadline(inputs)
	return pt_br2_task_settings_invalid_deadline(inputs)
});